import type { PropsWithChildren, ReactElement } from 'react'
import { inputLine } from '~/components/Form/Form.css'

export const InputLine = ({ children }: PropsWithChildren): ReactElement => {
  return <div className={inputLine}>{children}</div>
}
